const apiErrorCodes = [
  "internal-server-error",
  "service-unavailable",
  "user-not-authenticated",
  "user-session-timeout",
  "token-generate-failed",
] as const;

export type ApiErrorCode = (typeof apiErrorCodes)[number];

export interface ApiError {
  errorCode: ApiErrorCode;
}

export function isApiError(x: unknown): x is ApiError {
  return (
    typeof x === "object" &&
    x !== null &&
    "errorCode" in x &&
    typeof x.errorCode === "string" &&
    apiErrorCodes.includes(x.errorCode as ApiErrorCode)
  );
}
export function parseApiErrorCode(value: unknown): ApiErrorCode | undefined {
  return apiErrorCodes.includes(value as ApiErrorCode)
    ? (value as ApiErrorCode)
    : undefined;
}
export interface ErrorResponse<Data = unknown> {
  error: true;
  url: string;
  statusCode: number;
  statusMessage: string;
  message: string;
  data?: Data;
}

export function isErrorResponse(x: unknown): x is ErrorResponse {
  return (
    x !== null && typeof x === "object" && "error" in x && x.error === true
  );
}
